import { PLAN_MANAGEMENT_V2 } from '../../../../paths'

export const PLAN_SERVICE_AREA_OVERRIDES = `/${PLAN_MANAGEMENT_V2}/overrides/service-areas`

export const planServiceAreaOverridesPath = (subtab?: string) =>
  subtab
    ? `${PLAN_SERVICE_AREA_OVERRIDES}/${subtab.toLowerCase()}`
    : `${PLAN_SERVICE_AREA_OVERRIDES}/inactive`
